import React from 'react';
import AppRoutes from './routes';
import { Provider } from "react-redux";
import { store } from "./store";
import momenttz from 'moment-timezone';
import 'antd/dist/antd.css';
import './styles/main.scss'
import { DEFAULT_TIME_ZONE } from './store/definitions/timeZones';

momenttz.tz.setDefault(DEFAULT_TIME_ZONE);

const App = () => {
  return (
    <Provider store={store}>
      <div className="App">
        <AppRoutes />
      </div>
    </Provider>
  );
}

export default App;
